import type { ResolvedObjectAction } from "@/object-actions/types";

/**
 * Multi-selection chrome for the left rail — currently hidden. The selection
 * count and bulk actions surface through the right-click multi-selection menu
 * instead (see `RailMultiSelectionMenuProvider`). The component and its host
 * wiring are kept so the floating-bar treatment can return without re-plumbing.
 */
export function RailSelectionBar(_props: {
  count: number;
  registryActions: ResolvedObjectAction[];
  onClose: () => void;
}) {
  return null;
}
